module.exports = __webpack_public_path__ + "static/media/watch-heart.135dc217.svg";